module.exports = __webpack_public_path__ + "static/img/tx2.34498caf.png";